import { queryOptions } from "@tanstack/react-query";

export const noFetchQueryOptions = {
  throwOnError: true,
  queryFn: () => {
    throw new Error(
      "This query config is only used for query keys, do not use it for fetching data",
    );
  },
};

export const getKeyOnlyQueryConfig = <T = unknown>(key: T[]) =>
  queryOptions({
    queryKey: key,
    ...noFetchQueryOptions,
  });
